// extracted by mini-css-extract-plugin
module.exports = {"watermark":"PhotoWatermarkConfig_watermark__-Mrj6","spacing":"PhotoWatermarkConfig_spacing__2qQ-q"};